<template>
   <div class="body" v-if="is_loading">
        <!-- 네비게이션 -->
        <Head :time="current_time" :total_question="total_question" :current_question="current_question" @next="next" :total_part="total_part" :current_part="part"></Head>

        <div class="wrap body-con">
            <h2>지시문을 읽고 이메일을 완성하세요.</h2>
            <!-- <h3>
                You are in charge of the Customer Service Division 
                of Hattie, a home appliance manufacturing 
                company. A new Microwave model called Anaren 
                launched two months ago, but after inspection, 
                you found out that there is a minor defect in the 
                manufacturing process, resulting in sparks being 
                produced when the microwave is in use. Write an 
                email to customers notifying the recall plan of the 
                model.
            </h3> -->
            <h3>
                {{modules.part[this.part][this.current_question].directive}}
            </h3>
            <!-- modules.part[this.part][this.current_question] -->
            <div class="txt-center">
                <!-- <p class="txt-red">Help Words </p>
                <div class="help-word">
                    {{modules.part[this.part][this.current_question].help_word}}
                </div> -->
            </div>
            <div>
                <p class="txt-gray-light">Word Count {{word_count}}</p>
                <textarea name="" id="" rows="5" class="mt-10" @keyup="inputWord"></textarea>
            </div>
        </div>

        <div class="wrap">
            <div class="btn-fixed" v-if="is_next"><button class="btn-full"  @click="next()">NEXT</button></div>
            <div class="btn-fixed"  v-if="!is_next"><button class="btn-full on" >NEXT</button></div>
        </div>

        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
import Head from '@/components/inc_head.vue';
export default {
    name: 'Pre_part06',
    components: {
        Footer,
        Head
    },
    data: () => ({
        current_time : {time:0},
        total_question:0,
        current_question:0,
        is_loading:false,
        modules:{},
        part:6,
        answer:"",
        type:"",
        total_part:{part:0},
        word_count:0,
        is_next:false
    }),
    mounted() {
        // console.log(btoa('{"total_part":"6","total_question":1,"module_name":"module3","type":"4","modules":{"part":{"6":[{"second":600,"number":"1","question":"","statement":{},"img_url":"","mp3_url":"","directive":"You are the manager of a large coffee manufacturer and now you plan to install efficient coffee machines from Machine World to all of your 850 branches located worldwide. Write an email to the manager of Machine World requesting a catalog, price list, discount offers, and warranty terms of the machines.\r\n","help_word":"offer, quotation, estimate, guarantee"}]}},"submit_answer":0}'))
    //    this.type = this.$route.params.type;
       this.getQuestion();
    },
    methods: {
        getQuestion(){
            var moduel_str = atob(this.$route.params.module);
            var module_json = JSON.parse(moduel_str);
            this.modules = module_json.modules;
            this.total_part = {part:parseInt(module_json.total_part)};
            this.total_question = module_json.total_question;
            this.current_question = parseInt(module_json.submit_answer);
            console.log(module_json.modules);
            this.current_time.time = module_json.modules.part[this.part][this.current_question].second * 1000;
            this.is_loading = true;
            // var params = {
            //     type:this.type,
            //     part:this.part
            // }
            // this.axios.get(this.axios.root + "/rest/module_info/getQuestions",{params:params}).then((res)=>{
            //     console.log(res);
            //     if(res.data.err == 0){
            //         this.total_part = {part:parseInt(res.data.data.total_part)};
            //         this.total_question = res.data.data.total_question;
            //         this.modules = res.data.data.modules;
            //         this.current_question = parseInt(res.data.data.submit_answer);
            //         this.current_time.time = this.modules.part[this.part][this.current_question].second * 1000;
            //         this.is_loading = true;
            //     }else if(res.data.err == 5000){
            //         alert(res.data.err_msg);
            //         sessionStorage.clear();
            //         location.href="/intro";
            //     }else if(res.data.err == 6002){
            //         alert(res.data.err_msg);
            //         this.$router.push('/test_end/'+this.type);
            //     }else{
            //         alert(res.data.err_msg);
            //         return false;
            //     }
            // })
        },
        next(){
            this.answer = this.answer.trim();
            this.answer = "";
            this.memetos = [];
            this.select_item = [];
            this.word_count = 0;
            this.current_question++;
            this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
            // var params = {
            //     part :this.part,
            //     number : (this.current_question+1),
            //     type:this.type,
            //     student_idx:sessionStorage.getItem("student_idx"),
            //     answer:this.answer
            // }
            // this.axios.post(this.axios.root + "/rest/access/answerSubmit",params).then((res) => {
            //     if(res.data.err == 0){
            //         this.answer = "";
            //         this.memetos = [];
            //         this.select_item = [];
            //          this.word_count = 0;
            //         if((this.current_question + 1) == this.modules.part[this.part].length){
            //             this.$router.push('/test_end/'+this.type);
            //         }else{
            //             this.current_question++;
            //             this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
            //         }
            //     }else{
            //         alert(res.data.err_msg);
            //         return false;
            //     }
            // });
        },
        inputWord(e){
            this.answer = e.target.value;
            // console.log(this.answer);
            var answerSplit = this.answer.split(" ");
            // console.log(answerSplit.length - 1);
            // this.word_count = this.answer.replace(/ /gi, "").length;
            this.word_count = answerSplit.length - 1;
            this.is_next = true;
        }

    }
}
</script>